import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html,
  body,
  #root {
    width: 100%;
    min-height: 100%;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
    scroll-padding-top: 88px;
    color-scheme: ${({ theme }) => theme.mode};
  }

  body {
    margin: 0;
    min-width: 320px;
    position: relative;
    overflow-x: hidden;

    font-family: ${({ theme }) => theme.fonts.sans};
    font-size: 15px;
    font-weight: 400;
    line-height: 1.65;
    letter-spacing: -0.015em;

    color: ${({ theme }) => theme.colors.textPrimary};
    background-color: ${({ theme }) => theme.colors.background};

    word-break: keep-all;
    overflow-wrap: anywhere;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    letter-spacing: -0.02em;
    line-height: 1.35;
  }

  p {
    margin: 0;
  }

  ul,
  ol {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  button,
  input,
  textarea,
  select {
    font: inherit;
    color: inherit;
  }

  button {
    padding: 0;
    border: 0;
    background: none;
    cursor: pointer;
    touch-action: manipulation;
  }

  input,
  textarea,
  select {
    border: 0;
    outline: none;
    background: none;
  }

  textarea {
    resize: vertical;
  }

  img,
  svg {
    display: block;
    max-width: 100%;
  }

  table {
    border-spacing: 0;
    border-collapse: collapse;
  }

  :disabled {
    cursor: not-allowed;
  }

  ::selection {
    background: ${({ theme }) => theme.colors.primarySoft};
    color: ${({ theme }) => theme.colors.textPrimary};
  }

  :focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  input[type='checkbox'], input[type='radio'] {
    accent-color: ${({ theme }) => theme.colors.primary};
  }

  [hidden] { display: none !important; }

  @media (max-width: 768px) {
    input, textarea, select {
      font-size: 16px !important;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    html { scroll-behavior: auto; }
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.border};
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.borderStrong};
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => theme.colors.border} transparent;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes pulseGlow {
    0%,
    100% {
      box-shadow: 0 0 4px ${({ theme }) => theme.colors.accentGlow};
    }
    50% {
      box-shadow: 0 0 12px ${({ theme }) => theme.colors.accentGlowStrong};
    }
  }
`;
